import React from 'react';

const UrgentPreachingSection = () => {
  return (
    <section className="urgent-preaching-section">
      <div className="container">
        <div className="content-card">
          <h2 className="section-heading">The Most Urgent Preaching Activity</h2>
          
          <blockquote className="prabhupada-quote">
            <p>
              "Distribute books, as many as possible. If anyone hears something philosophy from us, that will help him. But if he purchases one book that may turn his life. So selling books is <strong>the best preaching activity</strong>. Sell books, hold the kirtana in public places like schools and colleges, preach—if you practice these things, and try to improve them more and more simply by your practicing sincerely, that simple program will please Krishna the most and you will see that very soon."
            </p>
            <footer>
              <cite>~ Srila Prabhupada, Letter to Sudama -- Bombay 25 November, 1972</cite>
            </footer>
          </blockquote>
        </div>
      </div>
    </section>
  );
};

export default UrgentPreachingSection;